import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {},
    paragraph: {
      fontWeight: 500,
      fontSize: '1rem',
      color: palette.common.black
    },
    boldParagraph: {
      fontWeight: 600,
      fontSize: '1.25rem',
      color: palette.common.black
    },
    modalLineProduct: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '5px 10px'
    },
    modalLineInfo: {
      display: 'flex',
      alignItems: 'center',
      gap: '20px'
    },
    modalLineImg: {
      width: '80px',
      height: '80px'
    },
    formContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: '15px'
    },
    switchTextContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '5px'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
